import { useEffect, useState } from "react";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../firebaseConfig";
import notificationApi from "../api/notifications";
import { message } from "antd";

export const usePushToken = () => {
  const [token, setToken] = useState<string | null>(null);
  const [permission, setPermission] = useState<NotificationPermission>(
    typeof Notification !== "undefined" ? Notification.permission : "default",
  );

  const ensureToken = async () => {
    try {
      const currentToken = await getToken(messaging);

      if (currentToken) {
        setToken(currentToken);
        // Register token with backend
        // TODO: Backend endpoint for token registration is currently 404 (Not Found).
        // Temporarily disabling to clean up console logs.
        /*
        notificationApi.registerPushToken({
          token: currentToken,
          callback: (_res: any) => {},
        });
        */
      }
    } catch (error) {
      console.error("Failed to retrieve push token", error);
    }
  };

  const requestPermission = async () => {
    if (typeof Notification === "undefined")
      return "default" as NotificationPermission;

    try {
      let nextPermission = Notification.permission;

      if (nextPermission === "default") {
        nextPermission = await Notification.requestPermission();
      }

      setPermission(nextPermission);

      if (nextPermission === "granted") {
        await ensureToken();
      }

      return nextPermission;
    } catch (error) {
      console.error("Failed to request notification permission", error);
      return typeof Notification !== "undefined"
        ? Notification.permission
        : ("default" as NotificationPermission);
    }
  };

  useEffect(() => {
    if (permission === "granted" && !token) {
      ensureToken();
    }
  }, [permission, token]);

  // Handle foreground messages
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      // Show toast notification
      message.info({
        content: `${payload.notification?.title}: ${payload.notification?.body}`,
        duration: 5,
        style: { marginTop: "10vh" },
      });
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return { token, permission, requestPermission };
};
